import { useEffect, useState } from "react";
import { api } from "./api";

export const CATEGORIES = [
  { key: "alimentacao", name: "Alimentação" },
  { key: "bebidas", name: "Bebidas" },
  { key: "higiene-beleza", name: "Higiene e Beleza" },
  { key: "casa-limpeza", name: "Casa e Limpeza" },
  { key: "mercearia", name: "Mercearia" },
  { key: "congelados", name: "Congelados" },
  { key: "eletronica", name: "Eletrónica" },
  { key: "moda", name: "Moda" },
  { key: "produtos-stp", name: "Produtos STP" },
];

export const DISTRICTS = ["Água Grande", "Mé-Zóchi", "Lobata", "Lembá", "Cantagalo", "Caué", "Região Autónoma do Príncipe"];

let cache = CATEGORIES;
let loading = null;
const subs = new Set();

export function reloadCategories() {
  loading = api.get("/categories").then(({ data }) => { cache = data; subs.forEach((f) => f(cache)); }).catch(() => {});
  return loading;
}

export function useCategories() {
  const [cats, setCats] = useState(cache);
  useEffect(() => {
    subs.add(setCats);
    if (!loading) reloadCategories();
    return () => subs.delete(setCats);
  }, []);
  return cats;
}
